/* Decor Walay — global.js */

document.addEventListener('DOMContentLoaded', function () {

  /* ---- Desktop mobile nav toggle (old simple one, kept for fallback) --- */
  var oldToggle = document.querySelector('[data-mobile-nav-toggle]');
  var oldNav    = document.querySelector('[data-mobile-nav]');
  if (oldToggle && oldNav) {
    oldToggle.addEventListener('click', function () {
      var isOpen = oldNav.classList.toggle('is-open');
      oldToggle.setAttribute('aria-expanded', isOpen);
    });
  }

  /* ---- Mobile Nav Drawer ------------------------------------------------ */
  var mobNav     = document.getElementById('MobNav');
  var navDataEl  = document.getElementById('MobNavData');
  if (mobNav && navDataEl) {
    var navData = JSON.parse(navDataEl.textContent);

    var L1 = document.getElementById('MobNavL1');
    var L2 = document.getElementById('MobNavL2');
    var L3 = document.getElementById('MobNavL3');
    var L2List  = document.getElementById('MobNavL2List');
    var L3List  = document.getElementById('MobNavL3List');
    var L2Title = document.getElementById('MobNavL2Title');
    var L3Title = document.getElementById('MobNavL3Title');

    /* Open */
    var openBtns = document.querySelectorAll('[data-mobile-nav-toggle]');
    openBtns.forEach(function(btn) {
      btn.addEventListener('click', function () {
        mobNav.classList.add('is-open');
        mobNav.setAttribute('aria-hidden', 'false');
        document.body.classList.add('mob-nav-open');
        btn.setAttribute('aria-expanded', 'true');
      });
    });

    /* Close */
    function closeNav() {
      mobNav.classList.remove('is-open');
      mobNav.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('mob-nav-open');
      openBtns.forEach(function(b) { b.setAttribute('aria-expanded', 'false'); });
      setTimeout(resetLevels, 300);
    }
    document.querySelectorAll('[data-mobile-nav-close]').forEach(function(el) {
      el.addEventListener('click', closeNav);
    });

    /* Reset levels to L1 */
    function resetLevels() {
      L2.classList.remove('is-active');
      L3.classList.remove('is-active');
      L1.classList.remove('is-behind');
      L2.classList.remove('is-behind');
    }

    /* Build list items for L2 / L3 */
    function buildList(ul, items, level) {
      ul.innerHTML = '';
      items.forEach(function(item, i) {
        var li = document.createElement('li');
        li.className = 'mob-nav__item';
        if (item.links && item.links.length > 0) {
          var btn = document.createElement('button');
          btn.className = 'mob-nav__row mob-nav__row--has-sub';
          btn.innerHTML = '<span>' + item.title + '</span><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M9 18l6-6-6-6"/></svg>';
          btn.addEventListener('click', function() {
            if (level === 2) {
              L3Title.textContent = item.title;
              buildList(L3List, item.links, 3);
              L2.classList.add('is-behind');
              L3.classList.add('is-active');
              L3.setAttribute('aria-hidden', 'false');
            }
          });
          li.appendChild(btn);
        } else {
          var a = document.createElement('a');
          a.className = 'mob-nav__row';
          a.href = item.url;
          a.textContent = item.title;
          li.appendChild(a);
        }
        ul.appendChild(li);
      });
    }

    /* L1 drill buttons */
    document.querySelectorAll('[data-mob-drill]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var idx = parseInt(btn.getAttribute('data-mob-index'), 10);
        var title = btn.getAttribute('data-mob-title');
        var item = navData[idx];
        if (!item) return;
        L2Title.textContent = title;
        buildList(L2List, item.links, 2);
        L1.classList.add('is-behind');
        L2.classList.add('is-active');
        L2.setAttribute('aria-hidden', 'false');
        L3.classList.remove('is-active');
        L3.classList.remove('is-behind');
      });
    });

    /* Back buttons */
    document.querySelectorAll('[data-mob-back]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var target = parseInt(btn.getAttribute('data-mob-back'), 10);
        if (target === 1) {
          L2.classList.remove('is-active');
          L2.setAttribute('aria-hidden', 'true');
          L1.classList.remove('is-behind');
        } else if (target === 2) {
          L3.classList.remove('is-active');
          L3.setAttribute('aria-hidden', 'true');
          L2.classList.remove('is-behind');
        }
      });
    });

    /* Close on Escape */
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && mobNav.classList.contains('is-open')) closeNav();
    });
  }

  /* ---- Scroll-to-top ---------------------------------------------------- */
  var scrollBtn = document.querySelector('[data-scroll-top]');
  if (scrollBtn) {
    window.addEventListener('scroll', function () {
      scrollBtn.classList.toggle('is-visible', window.scrollY > 500);
    });
    scrollBtn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  /* ---- Mega menu featured-product carousel ------------------------------ */
  Array.prototype.slice.call(document.querySelectorAll('[data-featured-carousel]')).forEach(function (carousel) {
    var slides = Array.prototype.slice.call(carousel.querySelectorAll('.mega-menu__featured-product'));
    if (slides.length < 2) return;
    var current = 0;
    var speed   = parseInt(carousel.getAttribute('data-autoplay-speed'), 10) || 3000;
    var timer   = null;
    function goTo(index) {
      slides[current].classList.remove('is-active');
      current = (index + slides.length) % slides.length;
      slides[current].classList.add('is-active');
    }
    function start() { stop(); timer = setInterval(function () { goTo(current + 1); }, speed); }
    function stop()  { clearInterval(timer); timer = null; }
    var navItem = carousel.closest('.site-nav__item');
    if (navItem) {
      navItem.addEventListener('mouseenter', start);
      navItem.addEventListener('mouseleave', stop);
    } else { start(); }
  });

});
